import { createQueryKeys } from '@lukemorales/query-key-factory';

import { getCountryList } from '../clients/coreData.api';

export const countries = createQueryKeys('countries', {
    list: {
        queryKey: null,
        queryFn: () => getCountryList(),
    },
    comboBoxOptions: (searchQuery: string) => ({ queryKey: [{ searchQuery }] }),
    selectedComboBoxOption: (countryId: string) => ({ queryKey: [{ countryId }] }),
});
